import { cn } from "@/lib/utils";
import { Text } from "components/core/Text";
import { ComponentProps, HTMLAttributes, forwardRef } from "react";

import { Menu } from "./Menu";
import { MENU_DEFAULT_PADDING } from "./MenuContext";

const Component = forwardRef<
    HTMLDivElement,
    HTMLAttributes<HTMLDivElement> & {
        autoPadding?: boolean;
    }
>(({ children, autoPadding = false, className, ...props }, ref) => {
    return (
        <div
            ref={ref}
            className={cn(
                "flex flex-col overflow-auto",
                autoPadding && "py-2",
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
});

function MenuListHeader({
    children,
    className,
    ...props
}: {
    size?: ComponentProps<typeof Menu>["size"];
} & Omit<ComponentProps<typeof Text>, "variant" | "color">) {
    return (
        <Text
            className={cn("px-4 py-0.5", className)}
            variant="caption2"
            tag="header"
            color="text.secondary"
            {...props}
        >
            {children}
        </Text>
    );
}

const MenuList = Object.assign(Component, { Header: MenuListHeader });
Component.displayName = "MenuList";

export { MenuList };
